// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/img/icons/marevo-icon-close.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("/public/img//icons//checkbox.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("/public/img//icons//checkbox-active.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.summary-portal {
  width: 100%;
  height: 100%;
  position: fixed;
  background-color: rgba(26, 26, 26, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99999;
  top: 0;
}

.form-container {
  width: 60%;
  position: relative;
  background-color: #ffffff;
  padding: 40px;
}

.form {
  display: flex;
  flex-direction: column;
  gap: 25px;
}
.form label {
  position: absolute;
  font-family: "Inter", serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  color: #ff214a;
  transform: translateY(calc(-100% - 5px));
}
.form__header__title {
  font-family: "Inter", serif;
  font-weight: 500;
  font-size: 18px;
  line-height: 100%;
  letter-spacing: 0%;
  vertical-align: bottom;
  text-transform: uppercase;
  color: #2F2E2E;
}
.form__header__close {
  cursor: pointer;
  display: flex;
  width: 20px;
  height: 20px;
  position: absolute;
  top: 41px;
  right: 40px;
  transition: all 0.3s;
  border: none;
  outline: 0;
  background-color: transparent;
}
.form__header__close:hover {
  transform: rotate(180deg);
}
.form__header__close::after {
  content: "";
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  width: 20px;
  height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.form__group {
  display: flex;
  flex: 1;
}
.form__top {
  gap: 20px;
  display: flex;
  justify-content: space-between;
}
.form__bottom {
  display: flex;
  margin-bottom: 30px;
}
.form__input {
  position: relative;
  flex: 1;
  padding: 15px;
  border: 1px solid rgba(98, 154, 51, 0.3);
  font-family: "Inter", serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
}
.form__input::placeholder {
  color: #629A33;
  font-weight: 300;
}
.form__check-input {
  cursor: pointer;
  width: 18px;
  min-width: 18px;
  height: 18px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  margin-top: 1px;
  margin-right: 10px;
  position: relative;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
}
.form__check-input:checked {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  width: 18px;
  min-width: 18px;
  height: 18px;
}
.form__check {
  display: flex;
  align-items: self-start;
  margin-bottom: 20px;
}
.form__check__label {
  position: static !important;
  font-family: "Inter", serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  color: #3A3A3C !important;
  transform: translate(0) !important;
}
.form__check #agree-error {
  transform: translateY(calc(-100% - 5px));
}
.form__buttons {
  width: 100%;
  gap: 20px;
  display: flex;
}
.form__buttons__button {
  cursor: pointer;
  flex: 1;
  padding: 12px;
  font-size: 16px !important;
  text-transform: uppercase;
  outline: 0;
  border: 1px solid #629A33;
  background-color: #629A33;
  color: #ffffff;
  font-family: "Inter", serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  text-align: center;
  transition: all 0.3s;
}
.form__buttons__button--back {
  border: 1px solid #629A33;
  background-color: #ffffff;
  color: #629A33;
  padding: 12px 20px;
  transition: all 0.3s ease;
}
.form__buttons__button--back:hover {
  background-color: #629A33 !important;
  color: #ffffff !important;
  transform: translateY(-3px);
}
.form__buttons__button:hover {
  background-color: #1A1A1A;
  color: #ffffff;
  transform: translateY(-3px);
}

#comment {
  height: 100px;
  padding: 15px 15px 50px 15px;
}`, "",{"version":3,"sources":["webpack://./src/components/summary/summary-page/summary-page-portal/summaryPagePortal.scss","webpack://./src/styles/_variables.scss","webpack://./src/styles/_mixins.scss"],"names":[],"mappings":"AAGA;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,uCAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;EACA,MAAA;AAFF;;AAKA;EACE,UAAA;EACA,kBAAA;EACA,yBCVY;EDWZ,aAAA;AAFF;;AAKA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAFF;AAIE;EACE,kBAAA;EEiBF,2BAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kCAAA;EACA,8BAAA;EFrBE,cCrBQ;EDsBR,wCAAA;AAIJ;AAAI;EExBD,2BAAA;EF0BG,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;EACA,cAAA;AAEN;AACI;EACE,eAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,oBAAA;EACA,YAAA;EACA,UAAA;EACA,6BAAA;AACN;AACM;EACE,yBAAA;AACR;AAEM;EACE,WAAA;EACA,yDAAA;EACA,2BAAA;EACA,sBAAA;EACA,4BAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAAR;AAKE;EACE,aAAA;EACA,OAAA;AAHJ;AAME;EACE,SAAA;EACA,aAAA;EACA,8BAAA;AAJJ;AAOE;EACE,aAAA;EACA,mBAAA;AALJ;AAQE;EACE,kBAAA;EACA,OAAA;EACA,aAAA;EACA,wCAAA;EErDF,2BAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kCAAA;EACA,8BAAA;AFgDF;AACI;EACE,cClGS;EDmGT,gBAAA;AACN;AAKE;EACE,eAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;EACA,yDAAA;EACA,2BAAA;EACA,4BAAA;EACA,wBAAA;EACA,eAAA;EAEA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,wBAAA;EACA,qBAAA;AAJJ;AAMI;EACE,yDAAA;EACA,2BAAA;EACA,4BAAA;EACA,wBAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;AAJN;AA0BE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AAxBJ;AA0BI;EACE,2BAAA;EEnHJ,2BAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kCAAA;EACA,8BAAA;EF+GI,yBAAA;EACA,kCAAA;AAlBN;AAqBI;EACE,wCAAA;AAnBN;AAuBE;EACE,WAAA;EACA,SAAA;EACA,aAAA;AArBJ;AAuBI;EACE,eAAA;EACA,OAAA;EACA,aAAA;EACA,0BAAA;EACA,yBAAA;EACA,UAAA;EACA,yBAAA;EACA,yBCrLS;EDsLT,cCjLQ;ECqCZ,2BAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kCAAA;EACA,8BAAA;EFwII,kBAAA;EACA,oBAAA;AAfN;AAiBM;EACE,yBAAA;EACA,yBCxLM;EDyLN,cC9LO;ED+LP,kBAAA;EACA,yBAAA;AAfR;AAiBQ;EACE,oCAAA;EACA,yBAAA;EACA,2BAAA;AAfV;AAmBM;EACE,yBCvMO;EDwMP,cCtMM;EDuMN,2BAAA;AAjBR;;AAuBA;EACE,aAAA;EACA,4BAAA;AApBF","sourcesContent":["@use \"../../../../styles/variables\" as vars;\n@use \"../../../../styles/mixins\" as mixins;\n\n.summary-portal {\n  width: 100%;\n  height: 100%;\n  position: fixed;\n  background-color: rgba($color: vars.$black-color, $alpha: 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 99999;\n  top: 0;\n}\n\n.form-container {\n  width: 60%;\n  position: relative;\n  background-color: vars.$white-color;\n  padding: 40px;\n}\n\n.form {\n  display: flex;\n  flex-direction: column;\n  gap: 25px;\n\n  label {\n    position: absolute;\n    @include mixins.h4();\n    color: vars.$red-color;\n    transform: translateY(calc(-100% - 5px));\n  }\n\n  &__header {\n    &__title {\n      @include mixins.font-family-second();\n      font-weight: 500;\n      font-size: 18px;\n      line-height: 100%;\n      letter-spacing: 0%;\n      vertical-align: bottom;\n      text-transform: uppercase;\n      color: #2F2E2E;\n    }\n\n    &__close {\n      cursor: pointer;\n      display: flex;\n      width: 20px;\n      height: 20px;\n      position: absolute;\n      top: 41px;\n      right: 40px;\n      transition: all 0.3s;\n      border: none;\n      outline: 0;\n      background-color: transparent;\n\n      &:hover {\n        transform: rotate(180deg);\n      }\n\n      &::after {\n        content: \"\";\n        background-image: url(/public/img/icons/marevo-icon-close.svg);\n        background-position: center;\n        background-size: cover;\n        background-repeat: no-repeat;\n        width: 20px;\n        height: 20px;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n      }\n    }\n  }\n\n  &__group {\n    display: flex;\n    flex: 1;\n  }\n\n  &__top {\n    gap: 20px;\n    display: flex;\n    justify-content: space-between;\n  }\n\n  &__bottom {\n    display: flex;\n    margin-bottom: 30px;\n  }\n\n  &__input {\n    position: relative;\n    flex: 1;\n    padding: 15px;\n    border: 1px solid rgba($color: vars.$second-color, $alpha: 0.3);\n\n    &::placeholder {\n      color: vars.$second-color;\n      font-weight: 300\n    }\n\n    @include mixins.h4();\n  }\n\n  &__check-input {\n    cursor: pointer;\n    width: 18px;\n    min-width: 18px;\n    height: 18px;\n    background-image: url(/public/img//icons//checkbox.svg);\n    background-position: center;\n    background-repeat: no-repeat;\n    background-size: contain;\n    margin-top: 1px;\n\n    margin-right: 10px;\n    position: relative;\n    appearance: none; // Прибирає стандартний вигляд\n    -webkit-appearance: none;\n    -moz-appearance: none;\n\n    &:checked {\n      background-image: url(/public/img//icons//checkbox-active.svg);\n      background-position: center;\n      background-repeat: no-repeat;\n      background-size: contain;\n      width: 18px;\n      min-width: 18px;\n      height: 18px;\n    }\n\n    // &:checked::before {\n    //   content: \"\";\n    //   background-image: url(/public/img//icons//checkbox-active.svg);\n    //   background-position: center;\n    //   background-repeat: no-repeat;\n    //   background-size: contain;\n    //   position: absolute;\n    //   display: flex;\n    //   justify-content: center;\n    //   align-items: center;\n    //   top: 4px;\n    //   left: 4px;\n    //   width: 8px;\n    //   height: 8px;\n    //   // background-color: white; // Колір галочки\n    //   // transform: rotate(45deg); // Поворот для створення вигляду галочки\n    // }\n  }\n\n  &__check {\n    display: flex;\n    align-items: self-start;\n    margin-bottom: 20px;\n\n    &__label {\n      position: static !important;\n      @include mixins.h4();\n      color: vars.$black-color-second !important;\n      transform: translate(0) !important;\n    }\n\n    #agree-error {\n      transform: translateY(calc(-100% - 5px));\n    }\n  }\n\n  &__buttons {\n    width: 100%;\n    gap: 20px;\n    display: flex;\n\n    &__button {\n      cursor: pointer;\n      flex: 1;\n      padding: 12px;\n      font-size: 16px !important;\n      text-transform: uppercase;\n      outline: 0;\n      border: 1px solid vars.$second-color;\n      background-color: vars.$second-color;\n      color: vars.$white-color;\n      @include mixins.h4();\n      text-align: center;\n      transition: all 0.3s;\n\n      &--back {\n        border: 1px solid vars.$second-color;\n        background-color: vars.$white-color;\n        color: vars.$second-color;\n        padding: 12px 20px;\n        transition: all 0.3s ease;\n\n        &:hover {\n          background-color: vars.$second-color !important;\n          color: vars.$white-color !important;\n          transform: translateY(-3px);\n        }\n      }\n\n      &:hover {\n        background-color: vars.$black-color;\n        color: vars.$white-color;\n        transform: translateY(-3px);\n      }\n    }\n  }\n}\n\n#comment {\n  height: 100px;\n  padding: 15px 15px 50px 15px;\n}","$primary-color: #629A33;\n$secondary-color: #6c757d;\n$font-size-base: 16px;\n$second-color: #629A33;\n$second-color-1: #06aeef;\n$shadow-color: #47659314;\n$black-color:  #1A1A1A;\n$black-color-second: #3A3A3C;\n$white-color: #ffffff;\n$red-color: #ff214a;\n\n$margin-top-title-option: 10px;\n$padding-vertical-group-inputs: 20px;\n$width-interface: 39vw;\n","@use \"variables\" as vars;\n\n@mixin text-center {\n  text-align: center;\n}\n\n@mixin font-family {\n  font-family: \"Inter\", serif;\n}\n\n@mixin font-family-second {\n   font-family: \"Inter\", serif;\n}\n\n@mixin box-border($blur, $color) {\n  border: 0.5px solid $color;\n}\n\n@mixin box-border-solid($blur, $color) {\n  border: 1px solid $color;\n}\n\n@mixin box-shadow($color) {\n  box-shadow: 0px 0px 20px 0px rgba($color, 0.1);\n}\n\n@mixin radius() {\n  border-radius: 10px;\n}\n\n@mixin h2() {\n  font-family: \"Inter\", serif;\n  font-weight: 300;\n  font-size: 17px;\n  line-height: 100%;\n}\n\n@mixin h3() {\n  font-family: \"Inter\", serif;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 21px;\n}\n\n@mixin h4() {\n  font-family: \"Inter\", serif;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 21px;\n  text-align: left;\n  text-underline-position: from-font;\n  text-decoration-skip-ink: none;\n}\n\n@mixin h5() {\n  font-family: \"Inter\", serif;\n  font-size: 10px;\n  font-weight: 400;\n  line-height: 12px;\n  text-align: center;\n  text-underline-position: from-font;\n  text-decoration-skip-ink: none;\n}\n\n@mixin bold {\n  font-family: \"Inter\", serif;\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
